import { composeWithDevTools } from 'redux-devtools-extension';
import { createStore, combineReducers, applyMiddleware } from 'redux';
import authReducer from './reducer/auth';
import parcelReducer from './reducer/parcel';
import paymentReducer from './reducer/payment';
import dashboardReducer from './reducer/dashboard';
import { loadState, saveState } from './localStorage';
import { throttle } from 'lodash';
import ReduxThunk from 'redux-thunk';
import { reducer as toastrReducer } from 'react-redux-toastr';

const allReducer = combineReducers({
  auth: authReducer,
  parcel: parcelReducer,
  toastr: toastrReducer,
  payment: paymentReducer,
  dashboard: dashboardReducer,
});

const persistedState = loadState();
const store = createStore(allReducer, persistedState, composeWithDevTools(applyMiddleware(ReduxThunk)));

store.subscribe(
  throttle(() => {
    const { jwt, user } = store.getState().auth;
    const parcel = store.getState().parcel;
    const payment = store.getState().payment;
    const dashboard = store.getState().dashboard;
    saveState({ auth: { jwt, user }, parcel, payment, dashboard });
  }, 1000),
);

export default store;
